import { render, staticRenderFns } from "./XQuickViewButton.vue?vue&type=template&id=fd2ed3b0"
import script from "./XQuickViewButton.vue?vue&type=script&lang=js"
export * from "./XQuickViewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports